import React, { useEffect } from 'react'
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Grid, Tooltip, Typography } from '@mui/material'
import { TextFieldComponent } from '../../components/CustomFormElement'
import validators from '../../utils/validators';
import { makeStyles, useTheme } from '@mui/styles';
import { ErrorIcon, SuccessIcon } from '../../components/CustomIcons';
import theme from '../../theme.css';
import CustomSection from '../../components/CustomSection';
import CustomCircularProgress from '../../components/CustomCircularProgress';
import CustomButton from '../../components/CustomButton';
import { CustomSectionHeader } from '../../components/CustomSectionHeader';

const useStyles = makeStyles((theme) => ({
    content: {
        // padding: theme.spacing(2),
        // paddingTop: theme.spacing(10),
    },
    link: {
        color: theme.palette.text.link,
        textDecoration: 'none',
    },
    button: {
        textTransform: 'capitalize!important'
    },
    check_box: {
        padding: 0,
    },
    inform: {
        cursor: 'pointer',
    },
    inform_password: {
        position: 'relative',
    },
    inform_password_desc: {
        padding: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
        // marginTop: theme.spacing(3),
        borderRadius: theme.spacing(3),
        border: '1px solid ' + theme.palette.border.secondary,
        position: 'absolute',
        zIndex: 10,
        right: 0,
    },
    text_center: {
        textAlign: 'center',
    },
    error_field: {
        backgroundColor: theme.palette.background.default,
        color: 'red',
        fontWeight: 'bold',
        zIndex: 10,
        borderRadius: theme.spacing(1),
        border: '1px solid ' + theme.palette.border.secondary,
    }
}));

export default function RegisterViewV3(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const { palette } = useTheme();
    const { step, address, validations, onCheckEmail, showLoadingEmail, focusField, registerInfo, setStep, addressCached } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Grid xs={12} item backgroundColor={palette.common.white} borderRadius={theme.spacing(3)}>
            <Grid xs={12} item container justifyContent='center' className={classes.content}>
                <Grid xs={12} item container justifyContent='center'>
                    <Grid xs={12} item paddingX={4}>
                        {step == 'contact_info' && <Form
                            onSubmit={props.checkValidateContactInfo}
                            keepDirtyOnReinitialize //TODOV to keep input value. in previous no need but dont know why other fields are cleared after input email
                            initialValues={{
                                ...registerInfo,
                                email_address: registerInfo && registerInfo.email ? registerInfo.email : null,
                                mobile_number: registerInfo && registerInfo.phone_number ? registerInfo.phone_number : null,
                                confirm_password: registerInfo && registerInfo.password ? registerInfo.password : null,
                            }}
                            validate={(values) => {
                                const errors = {};
                                if (!values.id_number && !values.passport_number) {
                                    const errorMsg = 'You must enter either ID Number or Passport Number';
                                    errors.id_number = errorMsg;
                                    errors.passport_number = errorMsg;
                                }
                                return errors;
                            }}
                            render={({ handleSubmit, reset, submitting, pristine, values, invalid }) => (
                                <Grid xs={12} container item justify="center" alignItems="center" marginY={2}>
                                    <>
                                        <CustomSectionHeader
                                            title={t('create_your_account')}
                                            subtitle={t('create_your_account_desc')}
                                            stepsControl={props.stepsControl}
                                            virtualStep={"Package"}
                                        />
                                        <PersonalDetails t={t} classes={classes}
                                            validations={validations}
                                            showLoadingEmail={showLoadingEmail}
                                            values={values}
                                            focusField={focusField}
                                            registerInfo={registerInfo}
                                            onHandleUpload={props.onHandleUpload}
                                            onCheckEmail={onCheckEmail}
                                            onHandleBlur={props.onHandleBlur}
                                            onAddImage={props.onAddImage}
                                            setStep={setStep}
                                        />
                                        <Grid item container xs={12} justifyContent={'center'} my={2}>
                                            <CustomButton
                                                variant={'contained'}
                                                onClick={handleSubmit}
                                            >
                                                {t('btn_confirm_continue')}
                                            </CustomButton>
                                        </Grid>
                                    </>
                                </Grid>
                            )}
                        />}
                        {step == 'address_info' && <Form
                            onSubmit={props.checkValidateAddress}
                            keepDirtyOnReinitialize //TODOV to keep input value. in previous no need but dont know why other fields are cleared after input email
                            initialValues={{
                                ...address,
                                apartment_name: addressCached?.mdu_name || address?.mdu_name,
                                apartment_number: addressCached?.mdu_unitno || address?.mdu_unitno,
                                street_number: addressCached?.street_number || address.street_number,
                                street_name: addressCached?.street_name || address.street_name,
                                town_city: addressCached?.town_city || address.town_city,
                                postal_code: addressCached?.postal_code || address?.postal_code,
                                state_province_county: addressCached?.state_province_county || address.state_province_county,
                            }}
                            render={({ handleSubmit, reset, submitting, pristine, values, invalid }) => (
                                <Grid item xs={12} container justify="center" alignItems="center" marginY={2}>
                                    <CustomSectionHeader
                                        title={t('rica_verification')}
                                        subtitle={t('rica_verification_desc')}
                                        stepsControl={props.stepsControl}
                                        virtualStep={"Registration"}
                                    />

                                    <HomeRICAAddress t={t} classes={classes} step address={address} />
                                    <Grid xs={12} paddingTop={5} item>
                                        <Grid item xs={12} textAlign='center' mb={1}>
                                            <CustomButton variant="contained" color="primary" onClick={handleSubmit}>{t('btn_confirm_continue')}</CustomButton>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}
                        />}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

function PersonalDetails(props) {
    const { t, classes, validations, onCheckEmail, showLoadingEmail, values } = props;
    console.log("validations: ", validations)
    return (
        <CustomSection
            title={t('persional_details')}
        >
            <Grid xs={12} item container direction='row' spacing={1}>
                <Grid item xs={12} sm={5.5}>
                    <Field
                        fullWidth
                        name="first_name"
                        component={TextFieldComponent}
                        placeholder={t('first_name') + '*'}
                        validate={validators.composeValidators(validators.required)}
                    />
                </Grid>
                <Grid item xs={0} sm={1}></Grid>
                <Grid item xs={12} sm={5.5}>
                    <Field
                        fullWidth
                        name="last_name"
                        component={TextFieldComponent}
                        placeholder={t('last_name') + '*'}
                        validate={validators.composeValidators(validators.required)}
                    />
                </Grid>
            </Grid>
            <Grid xs={12} item container direction='row' spacing={1}>
                <Grid item xs={12} sm={5.5}>
                    <Field
                        fullWidth
                        name="email_address"
                        component={TextFieldComponent}
                        placeholder={t('email_address') + '*'}
                        // autoFocus={focusField && focusField.email}
                        validate={validators.composeValidators(validators.required)}
                        onCustomOnBlur={(email) => onCheckEmail(email)}
                        endAdornment={showLoadingEmail === true ? <CustomCircularProgress /> : validations && validations.email === true ? <Tooltip title={t('invalid_email_format')} componentsProps={{ tooltip: { className: classes.error_field, }, }}><span><ErrorIcon /></span></Tooltip> : (validations.email === false && <SuccessIcon />)}
                    />
                </Grid>
                <Grid item xs={0} sm={1}></Grid>
                <Grid item xs={12} sm={5.5}>
                    <Field
                        fullWidth
                        name="mobile_number"
                        component={TextFieldComponent}
                        placeholder={t('mobile_number') + ', eg: 0812345674*'}
                        validate={validators.composeValidators(
                            validators.mustBeNumberRequired,
                            value => {
                                if (value && value.length !== 10) return t("phone_number_error");
                                if (value && value[0] !== '0') return t('phone_number_start_zero');
                                return undefined;
                            }
                        )} onCustomOnBlur={(e) => props.onHandleBlur(e.target.value, 'phone')}
                        endAdornment={validations && validations.phone === true ? <ErrorIcon /> : (validations.phone === false && <SuccessIcon />)}
                    // meta={{
                    //     touched: validations && validations.phone,
                    //     error: t('must_be_phone_length')
                    // }}
                    />
                </Grid>
            </Grid>
            <Grid xs={12} item container spacing={1} alignItems='center'>
                <Grid item xs={12} sm={5.5}>
                    <Field
                        fullWidth
                        name="password"
                        component={TextFieldComponent}
                        placeholder={t('password') + '*'}
                        type="password"
                        validate={validators.composeValidators(validators.required, validators.validNotMatch({ compareValue: values.password, message: t('enter_same_password') }, values.confirm_password))}
                        onCustomOnBlur={(e) => props.onHandleBlur(e.target.value, 'password')}
                        endAdornment={validations && validations.password === true ? <ErrorIcon /> : (validations && validations.password === false ? <SuccessIcon /> : null)}
                    // meta={{
                    //     touched: validations && validations.password,
                    //     error: t('must_be_password_length')
                    // }}
                    />
                </Grid>
                <Grid item xs={0} sm={1}></Grid>
                <Grid item xs={12} sm={5.5}>
                    <Field
                        fullWidth
                        name="confirm_password"
                        component={TextFieldComponent}
                        placeholder={t('confirm_password') + '*'}
                        type="password"
                        validate={validators.composeValidators(validators.required, validators.validNotMatch({ compareValue: values.password, message: t('enter_same_password') }, values.confirm_password))}
                        onCustomOnBlur={(e) => props.onHandleBlur(e.target.value, 'confirm_password')}
                        endAdornment={validations && validations.confirm_password === true ? <ErrorIcon /> : (validations.confirm_password === false ? <SuccessIcon /> : null)}
                    // meta={{
                    //     touched: validations && validations.confirm_password,
                    //     error: t('must_be_password_length')
                    // }}
                    />
                </Grid>
            </Grid>
            <Grid xs={12} item container alignItems='center' spacing={1}>
                <Grid item xs={12} sm={5.5}>
                    <Field
                        fullWidth
                        name="id_number"
                        component={TextFieldComponent}
                        placeholder={t('id_number')}
                        // validate={validators.composeValidators(validators.required)}
                        onCustomOnBlur={(e) => props.onHandleBlur(e.target.value, 'id_number')}
                    //endAdornment={validations && validations.id_number === true ? <ErrorIcon /> : (validations.id_number === false ? <SuccessIcon /> : null)}
                    // meta={{
                    //     touched: validations && validations.id_number,
                    //     error: t('must_be_id_number_length')
                    // }}
                    />
                </Grid>
                <Grid item xs={0} sm={1}>
                    <Grid item className={classes.text_center}>
                        <Typography variant='subtitle1'>{t('or')}</Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={5.5}>
                    <Field
                        fullWidth
                        name="passport_number"
                        component={TextFieldComponent}
                        placeholder={t('passport_number')}
                    />
                </Grid>
            </Grid>
            <Grid item xs={12} container justifyContent={'center'} alignItems={'center'}>
                <Grid item xs={12} sm={5.5}>
                    <Typography variant='subtitle1' textAlign={'center'} color={theme.palette.primary.main} fontWeight={'bold'}>{t('title_refer_friend')}</Typography>
                    <Typography textAlign={'center'}>{t('refer_a_friend_desc')}</Typography>
                    <Field
                        fullWidth
                        name="referral_code"
                        component={TextFieldComponent}
                        placeholder={t('placeholder_refer_friend')}

                    />
                    <Typography textAlign={'center'}>{t('persional_details_secure')}</Typography>
                </Grid>
            </Grid>
        </CustomSection>
    );
}

function HomeRICAAddress(props) {
    const { t, classes, address, step } = props;
    console.log("address HomeRICAAddress===", address);

    return (
        <CustomSection
            title={t('home_rica_address')}
        >

            <Grid xs={12} item container direction='row' spacing={1}>
                <Grid item xs={12} sm={5.5}>
                    <Field
                        fullWidth
                        name="street_number"
                        component={TextFieldComponent}
                        placeholder={t('address_streetnumber') + '*'}
                        validate={step == 1 && validators.composeValidators(validators.required)}
                    />
                </Grid>
                <Grid item xs={0} sm={1}></Grid>
                <Grid item xs={12} sm={5.5}>
                    <Field
                        fullWidth
                        name="street_name"
                        component={TextFieldComponent}
                        placeholder={t('address_streetname') + '*'}
                        validate={step == 1 && validators.composeValidators(validators.required)}
                    />
                </Grid>
            </Grid>
            <Grid xs={12} item container direction='row' spacing={1}>
                <Grid item xs={12} sm={5.5}>
                    <Field
                        fullWidth
                        name="town_city"
                        component={TextFieldComponent}
                        placeholder={t('address_towncity') + '*'}
                        validate={step == 1 && validators.composeValidators(validators.required)}
                    />
                </Grid>
                <Grid item xs={0} sm={1}></Grid>
                <Grid item xs={12} sm={5.5}>
                    <Field
                        fullWidth
                        name="postal_code"
                        component={TextFieldComponent}
                        placeholder={t('address_postalcode') + '*'}
                        validate={step == 1 && validators.composeValidators(validators.required)}
                    />
                </Grid>
            </Grid>
            <Grid xs={12} item container direction='row' spacing={1}>
                <Grid item xs={12}>
                    <Field
                        fullWidth
                        name="state_province_county"
                        component={TextFieldComponent}
                        placeholder={t('state_province_county') + '*'}
                        validate={step == 1 && validators.composeValidators(validators.required)}
                    />
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Field
                    fullWidth
                    name="apartment_name"
                    component={TextFieldComponent}
                    placeholder={t('address_apartment_name')}
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <Field
                    fullWidth
                    name="apartment_number"
                    component={TextFieldComponent}
                    placeholder={t('address_apartment_number')}
                />
            </Grid>
        </CustomSection>
    );
}
